let language = {
    // 
    STORE_ORDERS_EMPTY_STORE_1: "You don't have a Store yet,please go to",
    STORE_ORDERS_EMPTY_STORE_2: "stores",
    STORE_ORDERS_EMPTY_STORE_3: ", create a new store first.",
    
    // 
    STORE_ORDERS_ORDER_NUMBER_SEARCH_LABEL: "Order No:",
    STORE_ORDERS_ORDER_DATE_SEARCH_LABEL: "Order Dates:",

    STORE_ORDERS_SEARCH_BTN_TEXT: "Search",
    STORE_ORDERS_RESET_BTN_TEXT: "Reset",
    
    // 
    STORE_ORDERS_IS_EMPTY: "The store order is empty",
    
    // 
    STORE_ORDERS_SEARCH_EMPTY: "Could not find an order that met the specified criteria. Please modify the search criteria and try again.",
    
    // 
    STORE_ORDERS_NOT_STORE_INFO_ALERT_TITLE: "Store information missing",
    STORE_ORDERS_NOT_STORE_INFO_ALERT_CONTENT: "The current store does not exist.",
    
    STORE_ORDERS_ORDER_DATE_ERROR_TIP: "The start date must be less than the end date",
};

export { language }